meedy.controller('meedy.popupSignCertificatesController', ['$rootScope', '$mdDialog', 'title', 'message',
    function ($rootScope, $mdDialog, title, message) {
        var self = this;
        self.title = title || null;
        self.message = message;
        self.yesText = 'T.UI.APPLICATION.DELETE';
        self.noText = 'T.UI.APPLICATION.CANCEL';

        self.forms = {
            signPassword: null
        };

        self.save = function () {
            if (self.forms.signPassword.$valid) {
                var password = self.forms.signPassword.password.$viewValue;
                $mdDialog.hide(password);
            }
        };

        self.cancel = function () {
            $mdDialog.cancel();
        };
    }]);
